<iframe [src]="sanitizedLivenessUrl" width="600px" height="650px" frameborder="0" allow="camera; microphone"></iframe>